import React, { useEffect, useState, Fragment } from 'react'
import { Container, Row, Col, Button, Form, FormLabel, FormControl, Modal } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
//import { getCampaignsByFarm } from '../../actions/campaignsActions'
import { getFarms } from '../../actions/farmsActions'
import { getPlots, getPlotsByFarm } from '../../../src/actions/plotsActions'
import { getCrops, getCropsByPlot } from '../../../src/actions/cropsActions'
import { getLaborsByCrop } from '../../actions/laborsActions'
import { getMachineries } from '../../actions/machineriesActions'
import { getProducts } from '../../actions/productsActions'
import { getCardByOperator, addCard, editCard } from '../../actions/cardsActions'
import { getCardsauxForOperator, deniCardaux, acceptCardaux } from '../../actions/cardsauxActions'
import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select'
import jwtDecode from 'jwt-decode'
import customStyles from "../../components/design/select"
import moment from 'moment-timezone'
import Swal from 'sweetalert2'

export default function Input() {
    const { t } = useTranslation()
    const {logout} = useAuth()
    const dispatch = useDispatch()

    let token = jwtDecode(sessionStorage.getItem('jwt'))

    const days = ['domingo', 'lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado']
    const numberday = new Date().getDay()
    const nameday = days[numberday]

    const day = new Date().getDate()

    const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
    const numbermonth = new Date().getMonth()
    const namemonth = months[numbermonth]

    const year = new Date().getFullYear()

    const [hourMinute, setHourMinute] = useState('')

    const [latitude, setLatitude] = useState(0)
    const [longitude, setLongitude] = useState(0)
    const [location, setLocation] = useState(0)

    const {farms} = useSelector((state) => state.farms)
    const [farmOptions, setFarmsOptions] = useState({options: [], selected: null})

    // const {campaigns} = useSelector((state) => state.campaigns)
    // const [campaignOptions, setCampaignsOptions] = useState({options: [], selected: null})
    // const [campaignImage, setCampaignImage] = useState(null)

    const {plots} = useSelector((state) => state.plots)
    const [plotOptions, setPlotsOptions] = useState({options: [], selected: null})

    const {crops} = useSelector((state) => state.crops)
    const [cropOptions, setCropsOptions] = useState({options: [], selected: null})

    const {labors} = useSelector((state) => state.labors)
    const [laborOptions, setLaborsOptions] = useState({options: [], selected: null})
    const [laborImage, setLaborImage] = useState(null)

    const [extratimeSelected, setExtratimeSelected] = useState(0)
    

    const {machineries} = useSelector((state) => state.machineries)
    const [machineryOptions, setMachineriesOptions] = useState({options: [], selected: null})
    const [machineryHidden, setMachineryHidden] = useState(true)
    const [useMachinery, setUseMachinery] = useState(false)
    const [useMachineryRequire, setUseMachineryRequire] = useState(false)
    const [litresGasoil, setLitresGasoil] = useState(0)
    const [litresEngineOil, setLitresEngineOil] = useState(0)
    const [litresHydraulicOil, setLitresHydraulicOil] = useState(0)
    const [litresUrea, setLitresUrea] = useState(0)
    // const [litresAntifreeze, setLitresAntifreeze] = useState(0)
    const [litresGrease, setLitresGrease] = useState(0)
    
    const [fitosanitarioHidden, setFitosanitarioHidden] = useState(true)
    const [useFitosanitario, setUseFitosanitario] = useState(false)
    const [fitosanitarioRequire, setFitosanitarioRequire] = useState(false)
    const [imageAux, setImage] = useState(null)

    const {products} = useSelector((state) => state.products)
    const [productOptions, setProductsOptions] = useState({options: [], selected: null})
    const [productsForResume, setProductsForResume] = useState([])
    const [productsExtraForResume, setProductsExtraForResume] = useState([])

    const {card} = useSelector((state) => state.cards)
    const {cardsaux, cardsparent, cardsdenied, cardsaccept} = useSelector((state) => state.cardsaux)
    const [showModal, setShowModal] = useState(false)

    const [formState, setFormState] = useState({})
    
    const {user, datein, dateout, plot, crop, labor, extratime, extratimetype, machinery, litres_gasoil, litres_engine_oil, litres_hydraulic_oil, litres_urea, litres_grease, image, productList, product_extra, irrigation} = formState

    useEffect(() => {
        dispatch(getCardsauxForOperator(token?.id))
        dispatch(getCardByOperator(token?.id))
        let hour = moment(new Date()).hour()
        let minute = moment(new Date()).minutes()
        if (hour < 10) hour = 0 + hour
        if (minute < 10) minute = "0" + minute

        setHourMinute(hour+':'+minute)
    
        if ("geolocation" in navigator) {
            setLocation(1)
            navigator.geolocation.getCurrentPosition(function(position) {
                setLatitude(position.coords.latitude)
                setLongitude(position.coords.longitude)
            })
        } else {
            setLocation(0)
        }

        dispatch(getFarms())
        dispatch(getPlots())
        dispatch(getCrops())
        dispatch(getProducts())
    }, [token?.id, dispatch])

    useEffect(() => {
        if(card != null){
            setFormState({
                _id: card._id,
                user: card.user,
                datein: card.in,
                dateout: null,
                //campaign: card.campaign,
                plot: card.plot,
                crop: card.crop,
                labor: card.labor,
                extratime: card.extratime,
                extratimetype: card.extratimetype,
                machinery: null,
                litres_gasoil: null,
                litres_engine_oil: null,
                litres_hydraulic_oil: null,
                litres_urea: null,
                // litres_antifreeze: null,
                litres_grease: null,
                image: null,
                productList: [],
                product_extra: [],
                irrigation: {}
            })

            setExtratimeSelected(card.extratime / 3600000)

            if(card.labor.require_machinery === true){
                setUseMachineryRequire(true)
                setUseMachinery(true)
                setMachineryHidden(false)
                setFitosanitarioRequire(true)
                setUseFitosanitario(true)
                setFitosanitarioHidden(false)
            }

            setStep(7)
        }else{
            setFormState({
                user: token?.id,
                datein: null,
                dateout: null,
                //campaign: null,
                plot: null,
                crop: null,
                labor: null,
                extratime: 0,
                extratimetype: null,
                machinery: null,
                litres_gasoil: null,
                litres_engine_oil: null,
                litres_hydraulic_oil: null,
                litres_urea: null,
                // litres_antifreeze: null,
                litres_grease: null,
                image: null,
                productList: [],
                product_extra: [],
                irrigation: {}
            })
            setStep(0)
        }
    }, [token?.id, card])

    useEffect(() => {
        if(cardsaux.length > 0){
            setShowModal(true)
        }else{
            setShowModal(false)
        }
    }, [token?.id, cardsaux])

    const MINUTE_MS = 1000

    useEffect(() => {
        let hour = moment(new Date()).hour()
        let minute = moment(new Date()).minutes()
        if (hour < 10) hour = 0 + hour
        if (minute < 10) minute = "0" + minute
        setHourMinute(hour+':'+minute)

        const intervalId = setInterval(() => {
            hour = moment(new Date()).hour()
            minute = moment(new Date()).minutes()
            if (hour < 10) hour = 0 + hour
            if (minute < 10) minute = "0" + minute

            setHourMinute(hour+':'+minute)
        }, MINUTE_MS)
        return () => {
            clearInterval(intervalId)
        }
    }, [MINUTE_MS])

    const [step, setStep] = useState(0)

    useEffect(() => {
        if(farms){
            let selectFarmOptions = [{value: 0, label: t('global.select')}]
            let selectedFarmOption
            let firstItem = 0

            farms.forEach(farm => {
                let object = {value: farm._id, label: farm.name}
                selectFarmOptions.push(object)

                
                if(firstItem === 0){
                    selectedFarmOption = object
                    dispatch(getPlotsByFarm(selectedFarmOption.value))
                    firstItem++
                }
            })
            setFarmsOptions({options: selectFarmOptions, selected: selectedFarmOption})
        }
        //eslint-disable-next-line
    }, [farms])

    useEffect(() => {
        if(plots){
            let selectPlotOptions = [{value: 0, label: t('global.select')}]
            // let selectedPlotOption
            // let firstItem = 0
            
            plots.forEach(plot => {
                let object = {value: plot._id, label: plot.name}
                selectPlotOptions.push(object)

                // if(firstItem === 0){
                //     selectedPlotOption = object
                //     getCropsByPlot(selectedPlotOption.value)
                //     firstItem++
                // }
            })
            setPlotsOptions({options: selectPlotOptions, selected: {value: 0, label: t('global.select')}})
        }
        //eslint-disable-next-line
    }, [plots])

    useEffect(() => {
        if(crops){
            let selectCropOptions = [{value: 0, label: t('global.select')}]
            // let selectedCropOption
            // let firstItem = 0
            
            crops.forEach(crop => {
                let object
                if(crop.description !== undefined && crop.description !== ''){
                    object = {value: crop._id, label: crop.name+' ('+crop.description+')'}
                }else{
                    object = {value: crop._id, label: crop.name}
                }
                selectCropOptions.push(object)

                // if(firstItem === 0){
                //     selectedCropOption = object
                //     dispatch(getLaborsByCrop(crop._id))
                //     firstItem++
                // }
            })
            setCropsOptions({options: selectCropOptions, selected: {value: 0, label: t('global.select')}})
        }
        //eslint-disable-next-line
    }, [crops])

    // useEffect(() => {
    //     if(campaigns){
    //         let selectCampaignOptions = [{value: 0, label: t('global.select')}]
    //         let selectedCampaignOption

    //         let firstItem = 0
    //         campaigns.forEach(campaign => {
    //             let descriptioncampaign = ''
    //             if(campaign.description !== undefined){
    //                 descriptioncampaign += campaign.description+' | ' +campaign.plot.name+' - '+campaign.crop.name
    //             }else{
    //                 descriptioncampaign += campaign.plot.name+' - '+campaign.crop.name
    //             }

    //             if(campaign?.crop?.description !== undefined && campaign?.crop?.description !== ''){
    //                 descriptioncampaign += ' | '+campaign.crop.description
    //             }

    //             let object = {value: campaign._id, label: descriptioncampaign}

    //             dispatch(getLaborsByCrop(campaign.crop._id))
                
    //             selectCampaignOptions.push(object)
                
    //             if(firstItem === 0){
    //                 selectedCampaignOption = object
    //                 setCampaignImage(campaign.image)
    //                 firstItem++
    //             }
    //         })
    //         setCampaignsOptions({options: selectCampaignOptions, selected: selectedCampaignOption})
    //     }else{
    //         setCampaignsOptions({options: null, selected: null})
    //     }
    //     //eslint-disable-next-line
    // }, [campaigns])

    useEffect(() => {
        if(labors){
            let selectLaborOptions = [{value: 0, label: t('global.select')}]
            //let selectedLaborOption

            //let firstItem = 0
            labors.forEach(labor => {
                let object = {value: labor._id, label: labor.name}
                selectLaborOptions.push(object)

                // if(firstItem === 0){
                //     selectedLaborOption = object
                //     setLaborImage(labor.image)
                //     firstItem++
                // }
            })
            setLaborsOptions({options: selectLaborOptions, selected: {value: 0, label: t('global.select')}})
        }else{
            setLaborsOptions({options: null, selected: null})
        }
    }, [labors])

    useEffect(() => {
        if(products){
            let selectProductOptions = [{value: 0, label: t('global.select')}]
            // let selectedProductOption

            // let firstItem = 0
            products.forEach(product => {
                if(product.active){
                    let matterAux = t('landingoperator.nomatter')
                    if(product.matter !== undefined){
                        matterAux = product.matter
                    }
    
                    let object = {value: product._id, label: product.name+' ('+ matterAux +')'}
                    selectProductOptions.push(object)

                    // if(firstItem === 0){
                    //     selectedProductOption = object
                    //     firstItem++
                    // }
                }
            })
            setProductsOptions({options: selectProductOptions, selected: {value: 0, label: t('global.select')}})
        }else{
            setProductsOptions({options: null, selected: null})
        }
        //eslint-disable-next-line
    }, [products])

    const productChange = (target)=>{
        let selectProductOptions = [{value: 0, label: t('global.select')}]
        let selectedProductOption

        products.forEach(product => {
            if(product.active){
                let matterAux = t('landingoperator.nomatter')
                if(product.matter !== undefined){
                    matterAux = product.matter
                }

                let object = {value: product._id, label: product.name+' ('+ matterAux +')'}
                selectProductOptions.push(object)

                if(product._id === target.value){
                    selectedProductOption = object
                }
            }
        })
        setProductsOptions({options: selectProductOptions, selected: selectedProductOption})
    }

    const addProduct = () =>{
        let productsUsedState = formState.productList
        let valueQuantity = 0

        if(document.getElementById('quantity_product').value !== ''){
            valueQuantity = document.getElementById('quantity_product').value
        }

        productsUsedState.push({
            product: productOptions.selected.value,
            type: document.getElementById('type_product').value,
            quantity: valueQuantity
        })
        
        setProductsForResume([...productsForResume, {
            product: productOptions.selected.label,
            type: document.getElementById('type_product').value,
            quantity: valueQuantity
        }])

        setFormState({
            ...formState,
            productList: productsUsedState
        })

        if(products){
            let selectProductOptions = [{value: 0, label: t('global.select')}]
            let selectedProductOption

            let firstItem = 0
            products.forEach(product => {
                if(product.active){
                    let matterAux = t('landingoperator.nomatter')
                    if(product.matter !== undefined){
                        matterAux = product.matter
                    }
    
                    let object = {value: product._id, label: product.name+' ('+ matterAux +')'}
                    selectProductOptions.push(object)

                    if(firstItem === 0){
                        selectedProductOption = object
                        firstItem++
                    }
                }
            })
            setProductsOptions({options: selectProductOptions, selected: selectedProductOption})
        }else{
            setProductsOptions({options: null, selected: null})
        }

        document.getElementById('quantity_product').value = ''
        document.getElementById('type_product').value = 'Kg'
    }

    const removeProductX = (key) =>{
        let arrayProductsAux = formState.productList
        arrayProductsAux.splice(key, 1)

        let arrayProductsAux2 = productsForResume
        arrayProductsAux2.splice(key, 1)

        setFormState({...formState, productList: arrayProductsAux})
        setProductsForResume(arrayProductsAux2)
    }

    const addProductExtra = () =>{
        if(document.getElementById('name_product_extra').value !== ''){
            let productsExtraUsedState = formState.product_extra
            let valueQuantity = 0

            if(document.getElementById('quantity_product_extra').value !== ''){
                valueQuantity = document.getElementById('quantity_product_extra').value
            }

            productsExtraUsedState.push({
                product: document.getElementById('name_product_extra').value,
                type: document.getElementById('type_product_extra').value,
                quantity: valueQuantity
            })
            
            setProductsExtraForResume([...productsExtraForResume, {
                product: document.getElementById('name_product_extra').value,
                type: document.getElementById('type_product_extra').value,
                quantity: valueQuantity
            }])

            setFormState({
                ...formState,
                product_extra: productsExtraUsedState
            })

            document.getElementById('name_product_extra').value = ''
            document.getElementById('quantity_product_extra').value = ''
            document.getElementById('type_product_extra').value = 'Kg'
        }else{
            Swal.fire({
                showConfirmButton: true,
                icon: 'error',
                text: t('landingoperator.productin')
            })
        }
    }

    const removeProductExtraX = (key) =>{
        let arrayProductsAux = formState.product_extra
        arrayProductsAux.splice(key, 1)

        let arrayProductsAux2 = productsExtraForResume
        arrayProductsAux2.splice(key, 1)

        setFormState({...formState, product_extra: arrayProductsAux})
        setProductsExtraForResume(arrayProductsAux2)
    }

	const changeImage = (e) => {
		setImage(e.target.files[0])
        setFormState({...formState, image: e.target.files[0]})
	}

    const farmChange = (target)=>{
        let selectFarmOptions = [{value: 0, label: t('global.select')}]
        let selectedFarmOption

        farms.forEach(farm => {
            let object = {value: farm._id, label: farm.name}
            selectFarmOptions.push(object)

            if(farm._id === target.value){
                selectedFarmOption = object
                dispatch(getPlotsByFarm(selectedFarmOption.value))
            }
        })
        setFarmsOptions({options: selectFarmOptions, selected: selectedFarmOption})
    }

    const plotChange = (target)=>{
        let selectPlotOptions = [{value: 0, label: t('global.select')}]
        let selectedPlotOption

        plots.forEach(plot => {
            let object = {value: plot._id, label: plot.name}
            selectPlotOptions.push(object)

            if(plot._id === target.value){
                selectedPlotOption = object
                dispatch(getCropsByPlot(selectedPlotOption.value))
            }
        })
        setPlotsOptions({options: selectPlotOptions, selected: selectedPlotOption})
    }

    const cropChange = (target)=>{
        let selectCropOptions = [{value: 0, label: t('global.select')}]
        let selectedCropOption

        crops.forEach(crop => {
            let object
            if(crop.description !== undefined && crop.description !== ''){
                object = {value: crop._id, label: crop.name+' ('+crop.description+')'}
            }else{
                object = {value: crop._id, label: crop.name}
            }
            selectCropOptions.push(object)

            if(crop._id === target.value){
                selectedCropOption = object
                dispatch(getLaborsByCrop(crop._id))
            }
        })
        setCropsOptions({options: selectCropOptions, selected: selectedCropOption})
    }

    const laborChange = (target)=>{
        let selectLaborOptions = [{value: 0, label: t('global.select')}]
        let selectedLaborOption

        labors.forEach(labor => {
            let object = {value: labor._id, label: labor.name}
            selectLaborOptions.push(object)

            if(labor._id === target.value){
                selectedLaborOption = object
                setLaborImage(labor.image)
            }
        })
        setLaborsOptions({options: selectLaborOptions, selected: selectedLaborOption})
    }

    const changeExtraTime = (target) => {
        setExtratimeSelected(target.target.value)
        let extratimetypeSelected = null
        let extratimeNow = 0
        if(target.target.value > 0){
            extratimetypeSelected = 'extra'
            extratimeNow = target.target.value * 3600000
        }

        setFormState({
            ...formState,
            extratime: extratimeNow,
            extratimetype: extratimetypeSelected
        })
    }

    const handleCheckboxMachineryChange = (target) => {
        if (target.target.checked) {
            setMachineryHidden(false)
            setUseMachinery(true)
        }else{
            setMachineryHidden(true)
            setUseMachinery(false)
        }
    }
    
    const handleCheckboxFitosanitarioChange = (target) => {
        if (target.target.checked) {
            setFitosanitarioHidden(false)
            setUseFitosanitario(true)
        }else{
            setFitosanitarioHidden(true)
            setUseFitosanitario(false)
        }
    }

    useEffect(() => {
        if(machineries){
            let selectMachineryOptions = [{value: 0, label: t('global.select')}]
            let selectedMachineryOption

            let firstItem = 0
            machineries.forEach(machinery => {
                let object = {value: machinery._id, label: machinery.name+' ('+machinery.plate+')'}
                selectMachineryOptions.push(object)

                if(firstItem === 0){
                    selectedMachineryOption = object
                    firstItem++
                }
            })
            setMachineriesOptions({options: selectMachineryOptions, selected: selectedMachineryOption})
        }else{
            setMachineriesOptions({options: null, selected: null})
        }
    }, [machineries])

    const changeLitresGasoil = (target) => {
        setLitresGasoil(target.target.value)
    }

    const changeLitresEngineOil = (target) => {
        setLitresEngineOil(target.target.value)
    }

    const changeLitresHydraulicOil = (target) => {
        setLitresHydraulicOil(target.target.value)
    }

    const changeLitresUrea = (target) => {
        setLitresUrea(target.target.value)
    }

    // const changeLitresAntifreeze = (target) => {
    //     setLitresAntifreeze(target.target.value)
    // }

    const changeLitresGrease = (target) => {
        setLitresGrease(target.target.value)
    }

    const machineryChange = (target)=>{
        let selectMachineryOptions = [{value: 0, label: t('global.select')}]
        let selectedMachineryOption

        machineries.forEach(machinery => {
            let object = {value: machinery._id, label: machinery.name}
            selectMachineryOptions.push(object)

            if(machinery._id === target.value){
                selectedMachineryOption = object
            }
        })
        setMachineriesOptions({options: selectMachineryOptions, selected: selectedMachineryOption})
    }

    const [counterList, setCounterList] = useState([{ counter: "", quantity: 0 }])

    const handleInputChange = (e, index) => {
        const { name, value } = e.target
        const list = [...counterList]
        list[index][name] = value
        setCounterList(list)
    } 

    const handleRemoveClick = index => {
        const list = [...counterList]
        list.splice(index, 1)
        setCounterList(list)
    }

    const handleAddClick = () => {
        setCounterList([...counterList, { counter: "", quantity: 0 }])
    }

    const handleClick = (e) => {
        e.preventDefault()
        switch(step){
            case 0:
                setFormState({
                    ...formState,
                    datein: moment(new Date()).toDate()
                })

                let selectFarmOptions = [{value: 0, label: t('global.select')}]
                let selectedFarmOption
                if (farms !== undefined && farms !== null) {
                    let mindiff = 0
                    farms.forEach(farm => {
                        let object = {value: farm._id, label: farm.name}
                        let actualdiff = 0
                        selectFarmOptions.push(object)
                        
                        // if(Math.sign(latitude) === 1){
                        //     if(Math.sign(farm.latitude) === 1){
                        //         actualdiff = actualdiff + Math.abs(farm.latitude - latitude)
                        //     }else{
                        //         actualdiff = actualdiff + Math.abs(Math.abs(farm.latitude) + latitude)
                        //     }
                        // }else{
                        //     if(Math.sign(farm.latitude) === 1){
                        //         actualdiff = actualdiff + Math.abs(farm.latitude + Math.abs(latitude))
                        //     }else{
                        //         actualdiff = actualdiff + Math.abs(Math.abs(farm.latitude) - Math.abs(latitude))
                        //     }
                        // }
                        
                        // if(Math.sign(longitude) === 1){
                        //     if(Math.sign(farm.longitude) === 1){
                        //         actualdiff = actualdiff + Math.abs(farm.longitude - longitude)
                        //     }else{
                        //         actualdiff = actualdiff + Math.abs(Math.abs(farm.longitude) + longitude)
                        //     }
                        // }else{
                        //     if(Math.sign(farm.longitude) === 1){
                        //         actualdiff = actualdiff + Math.abs(farm.longitude + Math.abs(longitude))
                        //     }else{
                        //         actualdiff = actualdiff + Math.abs(Math.abs(farm.longitude) - Math.abs(longitude))
                        //     }
                        // }

                        // if(actualdiff < mindiff || mindiff === 0){
                            selectedFarmOption = {value: 0, label: t('global.select')}
                            //selectedFarmOption = object
                            dispatch(getPlotsByFarm(selectedFarmOption.value))
                            // mindiff = actualdiff
                        // }
                    })
                }
                setFarmsOptions({options: selectFarmOptions, selected: selectedFarmOption})

                setStep(step+1)
                break
            case 1:
                if(farmOptions?.selected?.value){
                    setStep(step+1)
                }else{
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'error',
                        text: t('landingoperator.selectfarm')
                    })
                }
                break
            case 2:
                if(plotOptions?.selected?.value){
                    setFormState({
                        ...formState,
                        //campaign: campaignOptions.selected.value
                        plot: plotOptions.selected.value
                    })
                    setStep(step+1)
                }else{
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'error',
                        text: t('landingoperator.selectplot')
                    })
                }
                break
            case 3:
                if(cropOptions?.selected?.value){
                    setFormState({
                        ...formState,
                        crop: cropOptions.selected.value
                    })
                    setStep(step+1)
                }else{
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'error',
                        text: t('landingoperator.selectcrop')
                    })
                }
                break
            case 4:
                if(laborOptions?.selected?.value){
                    setFormState({
                        ...formState,
                        labor: laborOptions.selected.value
                    })
                    setStep(step+1)
                }else{
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'error',
                        text: t('landingoperator.selectlabor')
                    })
                }
                break
            case 5:
                dispatch(addCard(user, datein, dateout, plot, crop, labor, extratime, extratimetype, machinery, litres_gasoil, litres_engine_oil, litres_hydraulic_oil, litres_urea, litres_grease, image, productList, product_extra, irrigation))

                setStep(step+1)
                break
            case 6:
                setStep(step+1)
                break
            case 7:
                setFormState({
                    ...formState,
                    dateout: moment(new Date()).toDate()
                })

                let selectMachineryOptions = [{value: 0, label: t('global.select')}]
                let selectedMachineryOption
                if (machineries !== undefined && machineries !== null) {
                    let firstItem = 0
                    machineries.forEach(machinery => {
                        let object = {value: machinery._id, label: machinery.name}
                        selectMachineryOptions.push(object)
                        if(firstItem === 0){
                            selectedMachineryOption = object
                            firstItem++
                        }
                    })
                }
                setMachineriesOptions({options: selectMachineryOptions, selected: selectedMachineryOption})

                dispatch(getMachineries())

                setStep(step+1)
                break
            case 8:
                if(useMachinery === true){
                    setFormState({
                        ...formState,
                        machinery: machineryOptions.selected.value,
                        litres_gasoil: litresGasoil,
                        litres_engine_oil: litresEngineOil,
                        litres_hydraulic_oil: litresHydraulicOil,
                        litres_urea: litresUrea,
                        // litres_antifreeze: litresAntifreeze,
                        litres_grease: litresGrease
                    })
                }
                
                if(fitosanitarioHidden === true){
                    setFormState({
                        ...formState,
                        image: image,
                        productList: [],
                    })
                }
                
                setStep(step+4)
                break
            case 9:
                setStep(step+1)
                break
            case 10:
                setFormState({
                    ...formState,
                    irrigation: {
                        counters: counterList.filter(counter => counter.counter !== ''),
                    }
                })

                setStep(step+2)
                break
            case 11:
                setStep(step+1)
                break
            case 12:
                dispatch(editCard(formState))
                
                setStep(step+1)
                break
            case 13:
                setStep(step+1)
                break
            default:
                break
        }
    }

    useEffect(() => {
        if(cardsdenied || cardsaccept){
            dispatch(getCardsauxForOperator(token?.id))
            if(cardsdenied){
                dispatch({type:'CARDAUX_DENI_RESET'})
            }else{
                dispatch({type:'CARDAUX_ACCEPT_RESET'})
            }
        }
    }, [cardsdenied, cardsaccept, token?.id, dispatch])

    const deleteCardaux = (target) => {
        dispatch(deniCardaux(target))
    }

    const updateCard = (cardauxId) => {
        dispatch(acceptCardaux(cardauxId))
    }

    const reloadDashboard = () => {
        window.location.reload()
    }

    return (
        <>
            <Container className='cuerpo'>
                {/* Header */}
                <Row className="text-left custom-card-header">
                    <Row>
                        <Col className='d-flex justify-conten-start align-items-center'>
                            <div style={step === 0 || step === 7 ? null : {display: "none"}}>
                                <i className="fa fa-user"></i> {t('landingoperator.step'+step+'.header.top')} {token?.firstname} {token?.lastname}
                            </div>
                            <div style={step !== 0 && step !== 7 ? null : {display: "none"}}>
                                {t('landingoperator.step'+step+'.header.top')}
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col className='d-flex justify-conten-start align-items-center'>
                            <div style={step === 0 ? null : {display: "none"}}>
                                {location === 1 && t('landingoperator.step'+step+'.header.bottomyes')}
                                {location === 0 && t('landingoperator.step'+step+'.header.bottomno')}
                            </div>
                            <div style={step !== 0 ? null : {display: "none"}}>
                                {t('landingoperator.step'+step+'.header.bottom')}
                            </div>
                        </Col>
                    </Row>
                </Row>

                {/* Body */}
                <Row className="text-left custom-card-body" style={step !== 6 && step !== 13 ? null : {display: "none"}}>
                    <Col className={step === 0 || step === 7 ? "text-center" : step !== 8 ? "d-flex justify-conten-start align-items-center" : "" }>
                        <div className="text-center" style={step === 0 ? null : {display: "none"}}>
                            {t('landingoperator.'+nameday)} {day} {t('landingoperator.de')} {t('landingoperator.'+namemonth)} {t('landingoperator.de')} {year}
                            <br/>
                            <h1>{hourMinute}</h1>
                        </div>
                        <div className='select-full' style={step === 1 ? null : {display: "none"}}>
                            <Form.Group>
                                <Select onChange={farmChange}
                                    placeholder={t('landingoperator.step'+step+'.body.bottom')}
                                    options={farmOptions.options}
                                    value={farmOptions.selected}
                                    styles={customStyles}
                                />
                            </Form.Group>
                        </div>
                        <div className='select-full' style={step === 2 ? null : {display: "none"}}>
                            {/* <Form.Group>
                                <Select 
                                    onChange={campaignChange}
                                    placeholder={t('landingoperator.step'+step+'.body.bottom')}
                                    options={campaignOptions.options}
                                    value={campaignOptions.selected}
                                    styles={customStyles}
                                />
                            </Form.Group>
                            {campaignImage
                            ?
                                <div className='text-center'>
                                    <img className='mt-3' src={campaignImage} width='500px' alt=''/>
                                </div>
                            :
                                <div className='mt-3'>{t('labors.thereisnt')}</div>
                            } */}
                            <Form.Group>
                                <Select 
                                    onChange={plotChange}
                                    placeholder={t('landingoperator.step'+step+'.body.bottom1')}
                                    options={plotOptions.options}
                                    value={plotOptions.selected}
                                    styles={customStyles}
                                />
                            </Form.Group>
                        </div>
                        <div className='select-full' style={step === 3 ? null : {display: "none"}}>
                            <Form.Group>
                                <Select 
                                    onChange={cropChange}
                                    placeholder={t('landingoperator.step'+step+'.body.bottom2')}
                                    options={cropOptions.options}
                                    value={cropOptions.selected}
                                    styles={customStyles}
                                />
                            </Form.Group>
                        </div>
                        <div className='select-full' style={step === 4 ? null : {display: "none"}}>
                            <Form.Group>
                                <Select onChange={laborChange}
                                    placeholder={t('landingoperator.step'+step+'.body.bottom')}
                                    options={laborOptions.options}
                                    value={laborOptions.selected}
                                    styles={customStyles}
                                />
                            </Form.Group>
                            {laborImage
                            ?
                                <img className='mt-3' src={laborImage} width='100%' alt=''/>
                            :
                                <div className='mt-3'>{t('labors.thereisnt')}</div>
                            }
                        </div>
                        <div className="custom-card-resume mx-auto" style={step === 5 ? null : {display: "none"}}>
                            <div className="mx-4">
                                <h1>{t('landingoperator.resume')}</h1>
                            </div>
                            <div className="m-4 resume">
                                <span>{t('landingoperator.farm')}:</span> {farmOptions?.selected?.label}<br/>
                            </div>
                            {/* <div className="m-4 resume">
                                <span>{t('landingoperator.campaign')}:</span> {campaignOptions?.selected?.label}<br/>
                            </div> */}
                            <div className="m-4 resume">
                                <span>{t('landingoperator.plot')}:</span> {plotOptions?.selected?.label}<br/>
                            </div>
                            <div className="m-4 resume">
                                <span>{t('landingoperator.crop')}:</span> {cropOptions?.selected?.label}<br/>
                            </div>
                            <div className="m-4 resume">
                                <span>{t('landingoperator.labor')}:</span> {laborOptions?.selected?.label}<br/>
                            </div>
                            {
                                formState.datein && step < 7 ?
                                    <div className="m-4 resume">
                                         <span>{t('landingoperator.datein')+': '}</span>{formState.datein?.getHours()}:{formState.datein?.getMinutes() < 10 ? '0'+formState.datein?.getMinutes() : formState.datein?.getMinutes()}
                                    </div>
                                :
                                    <></> 
                            }
                        </div>
                        <div className="text-center" style={step === 7 ? null : {display: "none"}}>
                            {t('landingoperator.'+nameday)} {day} {t('landingoperator.de')} {t('landingoperator.'+namemonth)} {t('landingoperator.de')} {year}
                            <br/>
                            <h1>{hourMinute}</h1>
                        </div>
                        <div style={step === 8 ? null : {display: "none"}}>
                            <div className="form-check">
                                <input className="form-check-input" id="check_machinery" type='checkbox' value='usemachinery' onChange={handleCheckboxMachineryChange} checked={useMachinery} disabled={useMachineryRequire}/>
                                <span className="form-check-label" htmlFor="check_machinery">{t('landingoperator.step'+step+'.body.bottomcheck')}</span>
                            </div><br/>
                            <div id="selectMachinery" className="mb-3" hidden={machineryHidden}>
                                <Form.Label>{t('landingoperator.machineryused')}</Form.Label>
                                <Form.Group>
                                    <Select onChange={machineryChange}
                                        placeholder={t('landingoperator.step'+step+'.body.bottomselect')}
                                        options={machineryOptions.options}
                                        value={machineryOptions.selected}
                                        styles={customStyles}
                                    />
                                </Form.Group><br/>
                                <Form.Label>{t('landingoperator.litres_gasoil')}</Form.Label>
                                <Form.Control
                                    type='number'
                                    name='litres_gasoil'
                                    value={litresGasoil}
                                    onChange={changeLitresGasoil}
                                /><br/>
                                <Form.Label>{t('landingoperator.litres_engine_oil')}</Form.Label>
                                <Form.Control
                                    type='number'
                                    name='litres_engine_oil'
                                    value={litresEngineOil}
                                    onChange={changeLitresEngineOil}
                                /><br/>
                                <Form.Label>{t('landingoperator.litres_hydraulic_oil')}</Form.Label>
                                <Form.Control 
                                    type='number'
                                    name='litres_hydraulic_oil'
                                    value={litresHydraulicOil}
                                    onChange={changeLitresHydraulicOil}
                                /><br/>
                                <Form.Label>{t('landingoperator.litres_urea')}</Form.Label>
                                <Form.Control
                                    type='number'
                                    name='litres_urea'
                                    value={litresUrea}
                                    onChange={changeLitresUrea}
                                />
                                <Form.Label>{t('landingoperator.litres_grease')}</Form.Label>
                                <Form.Control 
                                    type='number'  
                                    name='litres_grease'
                                    value={litresGrease}
                                    onChange={changeLitresGrease}
                                />
                                <div className="form-check mt-4">
                                    <input className="form-check-input" id="check_riego" type='checkbox' value='usedfitosanitario' onChange={handleCheckboxFitosanitarioChange} checked={useFitosanitario} disabled={fitosanitarioRequire}/>
                                    <span className="form-check-label" htmlFor="check_riego">{t('landingoperator.usedfitosanitario')}</span>
                                </div>
                            </div>
                            <div id="selectProducts" hidden={fitosanitarioHidden}>
                                <hr/>
                                <Form.Label>{t('landingoperator.products')}</Form.Label>
                                <Form.Group>
                                    <Select onChange={productChange}
                                        id='id_product'
                                        placeholder={t('landingoperator.productselect')}
                                        options={productOptions.options}
                                        value={productOptions.selected}
                                        styles={customStyles}
                                    />
                                </Form.Group><br/>
                                <div className='row'>
                                    <div className='col-6'>
                                        <Form.Control 
                                            id='quantity_product'
                                            type='number'  
                                            name='quantity_product'
                                            placeholder='0'
                                        />
                                    </div>
                                    <div className='col-6'>
                                        <Form.Control
                                            as="select"
                                            id='type_product'
                                            name='type_product'
                                            placeholder={t('landingoperator.step'+step+'.body.bottomtype')}
                                        >
                                            <option value='Kg' defaultValue>{t('products.kg')}</option>
                                            <option value='G'>{t('products.g')}</option>
                                            <option value='L'>{t('products.l')}</option>
                                            <option value='Cl'>{t('products.cl')}</option>
                                            <option value='Ml'>{t('products.ml')}</option>
                                        </Form.Control>
                                    </div>
                                    <div className='text-center'>
                                        <button onClick={addProduct} className="mt-4 mb-4 w-50">
                                            {t('landingoperator.addproduct')}
                                        </button>
                                    </div>
                                    {
                                        productsForResume?.map((product, key) =>{
                                            return (
                                                <Fragment key={key}>
                                                    <Form.Group className="mx-3">
                                                        <button className="form-label mx-2 btn btn-primary py-2 px-3" onClick={() => removeProductX(key)}><i className="fas fa-times"></i></button>
                                                        <Form.Label className="form-label mx-2">{product.product}</Form.Label>
                                                        <Form.Label className="form-label mx-2">{product.quantity}</Form.Label>
                                                        <Form.Label className="form-label mx-2">{product.type}</Form.Label>
                                                    </Form.Group><hr/>
                                                </Fragment>
                                            )
                                        })
                                    }
                                </div>
                                <FormLabel>{t('landingoperator.step'+step+'.body.bottomproductsextra')}</FormLabel>
                                <Form.Control
                                    id='name_product_extra'
                                    type='text'
                                    name='name_product_extra'
                                >
                                </Form.Control><br/>
                                <div className='row'>
                                    <div className='col-6'>
                                        <Form.Control 
                                            id='quantity_product_extra'
                                            type='number'
                                            name='quantity_product_extra'
                                            placeholder='0'
                                        />
                                    </div>
                                    <div className='col-6'>
                                        <Form.Control
                                            as="select"
                                            id='type_product_extra'
                                            name='type_product_extra'
                                            placeholder={t('landingoperator.step'+step+'.body.bottomtype')}
                                        >
                                            <option value='Kg' defaultValue>{t('products.kg')}</option>
                                            <option value='G'>{t('products.g')}</option>
                                            <option value='L'>{t('products.l')}</option>
                                            <option value='Cl'>{t('products.cl')}</option>
                                            <option value='Ml'>{t('products.ml')}</option>
                                        </Form.Control>
                                    </div>
                                    <div className='text-center'>
                                        <button onClick={addProductExtra} className="mt-4 mb-4 w-50">
                                            {t('landingoperator.addproductextra')}
                                        </button>
                                    </div>
                                    {
                                        productsExtraForResume?.map((product_extra, key) =>{
                                            return (
                                                <Fragment key={key}>
                                                    <Form.Group className="mx-3">
                                                        <button className="form-label mx-2 btn btn-primary py-2 px-3" onClick={() => removeProductExtraX(key)}><i className="fas fa-times"></i></button>
                                                        <Form.Label className="form-label mx-2">{product_extra.product}</Form.Label>
                                                        <Form.Label className="form-label mx-2">{product_extra.quantity}</Form.Label>
                                                        <Form.Label className="form-label mx-2">{product_extra.type}</Form.Label>
                                                    </Form.Group><hr/>
                                                </Fragment>
                                            )
                                        })
                                    }
                                </div>
                                <Form.Group className="mt-3">
                                    <Form.Label>{t('landingoperator.facture')}</Form.Label><br/><br/>
                                    { imageAux ? <img alt="Preview" height="60" src={typeof imageAux === 'string' ? imageAux : URL.createObjectURL(imageAux)} /> : null }<br/><br/>
                                    <input type="file" name="myImage" onChange={changeImage} /><br/><br/>
                                </Form.Group><br/><br/>
                            </div>
                        </div>
                        <div style={step === 10 ? null : {display: "none"}}>
                            <div id="selectRiego">
                                <Form.Label className="form-label mx-2">{t('landingoperator.counters')}</Form.Label>
                                {counterList.map((counter, key) => {
                                    return (
                                        <div key={key}>
                                            <div className="d-flex items-center justify-center align-items-center">
                                                <FormControl
                                                    name="counter"
                                                    className="m-3"
                                                    placeholder={t('landingoperator.counter')}
                                                    value={counter.firstName}
                                                    onChange={e => handleInputChange(e, key)}
                                                />
                                                <FormControl
                                                    type="number"
                                                    className="m-3"
                                                    name="quantity"
                                                    placeholder={t('landingoperator.quantity')}
                                                    value={counter.quantity}
                                                    onChange={e => handleInputChange(e, key)}
                                                />
                                                {counterList.length !== 1 && <button className="mr10" onClick={() => handleRemoveClick(key)}>{t('landingoperator.remove')}</button>}
                                            </div>
                                            {counterList.length - 1 === key && <button className="m-3" onClick={handleAddClick}>{t('landingoperator.anothercounter')}</button>}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className='select-full' style={step === 11 ? null : {display: "none"}}>
                            <Form.Label>{t('landingoperator.extratime')}</Form.Label>
                            <Form.Control 
                                type='number'  
                                name='extratime'
                                value={extratimeSelected}
                                onChange={changeExtraTime}
                            />
                        </div>
                        <div className="custom-card-resume mx-auto" style={step === 12 ? null : {display: "none"}}>
                            <div className="mx-4">
                                <h1>{t('landingoperator.resume')}</h1>
                            </div>
                            { useMachinery === true
                                ?
                                    <div className="m-4 resume">
                                        <span>{t('landingoperator.machinery')}:</span> {machineryOptions.selected?.label}<br/>
                                        <span>{t('landingoperator.litres_gasoil')}:</span> {litresGasoil}<br/>
                                        <span>{t('landingoperator.litres_engine_oil')}:</span> {litresEngineOil}<br/>
                                        <span>{t('landingoperator.litres_hydraulic_oil')}:</span> {litresHydraulicOil}<br/>
                                        <span>{t('landingoperator.litres_urea')}:</span> {litresUrea}<br/>
                                        {/* <span>{t('landingoperator.litres_antifreeze')}:</span> {litresAntifreeze}<br/> */}
                                        <span>{t('landingoperator.litres_grease')}:</span> {litresGrease}<br/>
                                    </div>
                                :
                                    <></>
                            }
                            {/* { fitosanitarioHidden === true
                                ?
                                    <div className="m-4 resume">
                                        <span>{t('landingoperator.counters')}:</span><br/>
                                        {counterList?.map((counter, key) =>{
                                            return (
                                                <Fragment key={key}><span key={key}> - {counter.counter}: {counter.quantity}</span><br/></Fragment>
                                            )
                                        })}
                                    </div>
                                :
                                    <></>
                            } */}
                            { fitosanitarioHidden === false
                                ?
                                    <div className="m-4 resume">
                                        <span>{t('landingoperator.products')}:</span><br/>
                                        {productsForResume?.map((product, key) =>{
                                            return (
                                                <Fragment key={key}><span key={key}> - {product.product}: {product.quantity}{product.type}</span><br/></Fragment>
                                            )
                                        })}
                                        <span>{t('landingoperator.otherproducts')}:</span><br/>
                                        {productsExtraForResume?.map((product, key) =>{
                                            return (
                                                <Fragment key={key}><span key={key}> - {product.product}: {product.quantity}{product.type}</span><br/></Fragment>
                                            )
                                        })}
                                    </div>
                                :
                                    <></>
                            }
                            {formState.datein && step > 7 ?
                                <div className="m-4 resume">
                                        <span>{t('landingoperator.dateout')+': '}</span>{formState.dateout?.getHours()}:{formState.dateout?.getMinutes() < 10 ? '0'+formState.dateout?.getMinutes() : formState.dateout?.getMinutes()}
                                </div>
                            :
                                <></> 
                            }
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col className='align-items-center text-center'>
                        <div style={step === 0 || step === 1 || step === 2 || step === 3 || step === 4 || step === 5 || step === 7 || step === 8 || step === 9 || step === 10 || step === 11 || step === 12 ? null : {display: "none"}}>
                            <Button onClick={handleClick} className="mt-3" type="submit">
                                <div style={step === 0 ? null : {display: "none"}}>
                                    {t('landingoperator.startcheckin')}
                                </div>
                                <div style={step === 1 || step === 2 || step === 3 || step === 4 ? null : {display: "none"}}>
                                    {t('landingoperator.continue')}
                                </div>
                                <div style={step === 5 ? null : {display: "none"}}>
                                    {t('landingoperator.checkin')}
                                </div>
                                <div style={step === 7 ? null : {display: "none"}}>
                                    {t('landingoperator.endcheckin')}
                                </div>
                                <div style={step === 8 || step === 9 || step === 10 || step === 11 ? null : {display: "none"}}>
                                    {t('landingoperator.continue')}
                                </div>
                                <div style={step === 12 ? null : {display: "none"}}>
                                    {t('landingoperator.checkout')}
                                </div>
                            </Button>
                        </div>
                        <div style={step === 12 || step === 5 ? null : {display: "none"}}>
                            <Button onClick={reloadDashboard} className="mt-3">
                                {t('landingoperator.step'+step+'.body.reset')}
                            </Button>
                        </div>
                        <div style={step === 13 ? null : {display: "none"}}>
                            <Button onClick={logout} className="mt-3 float-left">
                                {t('landingoperator.step'+step+'.body.logout')}
                            </Button>
                            <Button onClick={reloadDashboard} className="mt-3 float-right">
                                {t('landingoperator.step'+step+'.body.buttonhome')}
                            </Button>
                        </div>
                        <div style={step === 6 ? null : {display: "none"}}>
                            <Button onClick={logout} className="mt-3">
                                {t('landingoperator.step'+step+'.body.logout')}
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Modal show={showModal} backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title>{t('landingoperator.cardsaux')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {cardsaux?.map((cardaux, key) => {
                        return (
                            <div key={key}>
                                <div className="items-center justify-center align-items-center text-center">
                                    {t('landingoperator.cardof')+' '+moment(new Date(cardsparent[key]?.in)).format('DD/MM/YYYY')+' '+moment(new Date(cardsparent[key]?.in)).format('HH:mm')+'-'+moment(new Date(cardsparent[key]?.out)).format('HH:mm')}<br/><br/>
                                    {t('landingoperator.changes')}:<br/>
                                    {cardsparent[key]?.in !== cardaux.in ? <>{t('landingoperator.datein')+': '+moment(new Date(cardsparent[key]?.in)).format('HH:mm')+' -> '+moment(new Date(cardaux.in)).format('HH:mm')}<br/></> : <></>}
                                    {cardsparent[key]?.out !== cardaux.out ? <>{t('landingoperator.dateout')+': '+moment(new Date(cardsparent[key]?.out)).format('HH:mm')+' -> '+moment(new Date(cardaux.out)).format('HH:mm')}<br/></> : <></>}
                                    {cardsparent[key]?.plot?.farm?._id !== cardaux.plot?.farm?._id ? <>{t('landingoperator.farm')+': '+cardsparent[key]?.plot?.farm?.name+' -> '+cardaux.plot?.farm?.name}<br/></> : <></>}
                                    {cardsparent[key]?.plot?._id !== cardaux.plot?._id ? <>{t('landingoperator.plot')+': '+cardsparent[key]?.plot?.name+' -> '+cardaux.plot?.name}<br/></> : <></>}
                                    {cardsparent[key]?.crop?._id !== cardaux.crop?._id ? <>{t('landingoperator.crop')+': '+cardsparent[key]?.crop?.name+' -> '+cardaux.crop?.name}<br/></> : <></>}
                                    {cardsparent[key]?.labor?._id !== cardaux.labor?._id ? <>{t('landingoperator.labor')+': '+cardsparent[key]?.labor?.name+' -> '+cardaux.labor?.name}<br/></> : <></>}
                                    {cardsparent[key]?.machinery?._id !== cardaux.machinery?._id ? <>{t('landingoperator.machinery')+': '+cardsparent[key]?.machinery?.name+' -> '+cardaux.machinery?.name}<br/></> : <></>}
                                    {/* {cardsparent[key]?.litres_gasoil !== cardaux.litres_gasoil ? <>{t('landingoperator.litres_gasoil')+': '+cardsparent[key]?.litres_gasoil+' -> '+cardaux.litres_gasoil}<br/></> : <></>}
                                    {cardsparent[key]?.litres_engine_oil !== cardaux.litres_engine_oil ? <>{t('landingoperator.litres_engine_oil')+': '+cardsparent[key]?.litres_engine_oil+' -> '+cardaux.litres_engine_oil}<br/></> : <></>}
                                    {cardsparent[key]?.litres_hydraulic_oil !== cardaux.litres_hydraulic_oil ? <>{t('landingoperator.litres_hydraulic_oil')+': '+cardsparent[key]?.litres_hydraulic_oil+' -> '+cardaux.litres_hydraulic_oil}<br/></> : <></>}
                                    {cardsparent[key]?.litres_urea !== cardaux.litres_urea ? <>{t('landingoperator.litres_urea')+': '+cardsparent[key]?.litres_urea+' -> '+cardaux.litres_urea}<br/></> : <></>}
                                    {cardsparent[key]?.litres_grease !== cardaux.litres_grease ? <>{t('landingoperator.litres_grease')+': '+cardsparent[key]?.litres_grease+' -> '+cardaux.litres_grease}<br/></> : <></>} */}
                                    <br/><br/>
                                    <button className="btn btn-success mx-3" onClick={() => updateCard(cardaux._id)}>{t('landingoperator.accept')}</button>
                                    <button className="btn btn-danger mx-3" onClick={() => deleteCardaux(cardaux._id)}>{t('landingoperator.denied')}</button>
                                </div>
                                <hr/>
                            </div>
                        )
                    })}
                </Modal.Body>
            </Modal>
        </>
    )
}